import { HTMLAttributes } from "react"
import cc from "classcat"
import { Icon } from "./Icon"

export function Spinner({ className = "" }: HTMLAttributes<HTMLDivElement>) {
  const classes = cc(["spinner", className])
  return <Icon className={classes} name="spinner" />
}
